import React from "react";
import { colors2 } from "oolib";
import { UI_CAPTION } from "oolib/dist/v2/components/Typo2";

import { ConfigForm_SectionWrapper } from "../../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { WidgetFilters } from "../../../utils/WidgetFilters";
import { useWidgetFilterControls } from "../../../utils/useWidgetFilterControls";
import { DATASETS } from "../madSettings";

const CONTENT_TYPES_FOR_FILTERS = Object.keys(DATASETS);

/**
 * The widget's filters — the same WidgetFilters builder every other widget
 * uses, over the three assessment templates. The table is built from those
 * templates' docs, so a filter narrows the rows: only children with a
 * matching doc are listed. Stored at `<propsPath>.widgetFilters`, the key
 * every widget uses.
 */
export const AssessmentStatusConfigForm = ({ props, propsPath, widgetConfig, setConfig, underEditWidgetIdx }) => {
  const { filterHeaderProps, filterControlProps } = useWidgetFilterControls({ hasDimensions: true });

  return (
    <ConfigForm_SectionWrapper icon="Funnel" title="Filters" {...filterHeaderProps}>
      {!props.widgetFilters?.length && (
        <UI_CAPTION style={{ color: colors2.grey60, display: "block" }}>
          Narrow the table — only children with a matching assessment are listed.
        </UI_CAPTION>
      )}
      <WidgetFilters
        widgetConfig={widgetConfig}
        updateWidgetConfig={setConfig}
        widgetIndex={underEditWidgetIdx}
        configPath={`${propsPath}.widgetFilters`}
        contentTypesForFilters={CONTENT_TYPES_FOR_FILTERS}
        {...filterControlProps}
      />
    </ConfigForm_SectionWrapper>
  );
};
